module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/download-ab7bffd91461b4b42ce76049427e7812.svg";